/**
 * @generated SignedSource<<6a415c0e4c3f94e233ef19d482554498>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegrationStatusType = "APPROVED" | "PENDING" | "%future added value";
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type EditDigestJobDialogIntegrationsQuery$variables = {
  organizationId: any;
};
export type EditDigestJobDialogIntegrationsQuery$data = {
  readonly node: {
    readonly discordWebhooks?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: any;
          readonly name: string;
        };
      }>;
    };
    readonly id?: any;
    readonly integrations?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly integrationStatus: IntegrationStatusType | null | undefined;
          readonly integrationType: IntegrationType;
        };
      }>;
    };
    readonly slackChannels?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: any;
          readonly name: string;
          readonly slackChannelId: string | null | undefined;
        };
      }>;
    };
  } | null | undefined;
  readonly slackChannelsForDisplay: ReadonlyArray<{
    readonly id: string;
    readonly isMember: boolean;
    readonly isPrivate: boolean;
    readonly name: string;
  }>;
};
export type EditDigestJobDialogIntegrationsQuery = {
  response: EditDigestJobDialogIntegrationsQuery$data;
  variables: EditDigestJobDialogIntegrationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLIntegrationConnection",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": "slackChannels",
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "SLACK_CHANNEL"
    }
  ],
  "concreteType": "GraphQLNotificationIntegrationConnection",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLNotificationIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLNotificationIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slackChannelId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "notificationIntegrations(kind:\"SLACK_CHANNEL\")"
},
v6 = {
  "alias": "discordWebhooks",
  "args": [
    {
      "kind": "Literal",
      "name": "kind",
      "value": "DISCORD_WEBHOOK"
    }
  ],
  "concreteType": "GraphQLNotificationIntegrationConnection",
  "kind": "LinkedField",
  "name": "notificationIntegrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLNotificationIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLNotificationIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "notificationIntegrations(kind:\"DISCORD_WEBHOOK\")"
},
v7 = {
  "alias": "slackChannelsForDisplay",
  "args": [
    {
      "kind": "Literal",
      "name": "types",
      "value": "public_channel,private_channel"
    }
  ],
  "concreteType": "GraphQLSlackChannel",
  "kind": "LinkedField",
  "name": "slackChannels",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    }
  ],
  "storageKey": "slackChannels(types:\"public_channel,private_channel\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDigestJobDialogIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "GraphQLOrganization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDigestJobDialogIntegrationsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "GraphQLOrganization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v7/*: any*/)
    ]
  },
  "params": {
    "cacheID": "15e3d522c81ab9c40159372ef5e4bc97",
    "id": null,
    "metadata": {},
    "name": "EditDigestJobDialogIntegrationsQuery",
    "operationKind": "query",
    "text": "query EditDigestJobDialogIntegrationsQuery(\n  $organizationId: GlobalID!\n) {\n  node(id: $organizationId) {\n    __typename\n    ... on GraphQLOrganization {\n      id\n      integrations {\n        edges {\n          node {\n            integrationType\n            integrationStatus\n          }\n        }\n      }\n      slackChannels: notificationIntegrations(kind: SLACK_CHANNEL) {\n        edges {\n          node {\n            id\n            name\n            slackChannelId\n          }\n        }\n      }\n      discordWebhooks: notificationIntegrations(kind: DISCORD_WEBHOOK) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n    __isNode: __typename\n    id\n  }\n  slackChannelsForDisplay: slackChannels(types: \"public_channel,private_channel\") {\n    id\n    name\n    isMember\n    isPrivate\n  }\n}\n"
  }
};
})();

(node as any).hash = "84754fb03990e0232a5214398050dfc2";

export default node;
